import type { Project } from '@/api'
import type { User } from '@/types/auth'

import request, { type RequestConfig } from './request'

export type TaskSquareStatus = 'open' | 'paused' | 'closed'
export type TaskSquareAssignmentStatus = 'claimed' | 'in_progress' | 'reviewing' | 'completed' | 'failed'

export interface TaskSquareAssignment {
  id: number
  task_id: number
  assignee_id: number
  claimed_project_id: number
  status: TaskSquareAssignmentStatus
  progress_percent: number
  current_stage?: string | null
  workflow_state?: string | null
  note?: string | null
  claimed_at: string
  completed_at?: string | null
  assignee?: User | null
  claimed_project?: Project | null
}

export interface TaskSquareTask {
  id: number
  source_project_id: number
  publisher_id: number
  title: string
  summary?: string | null
  description?: string | null
  genre?: string | null
  target_duration?: number | null
  status: TaskSquareStatus
  allow_multiple_claims: boolean
  claim_count: number
  published_at: string
  created_at: string
  updated_at?: string | null
  publisher?: User | null
  source_project?: Project | null
  assignments: TaskSquareAssignment[]
  viewer_assignment?: TaskSquareAssignment | null
}

export interface TaskSquareListResponse {
  items: TaskSquareTask[]
  total: number
}

export interface TaskSquarePublishPayload {
  source_project_id: number
  title?: string
  summary?: string
  description?: string
  genre?: string
  target_duration?: number
  intake_payload?: Record<string, any>
  start_request?: Record<string, any>
  allow_multiple_claims?: boolean
}

export interface TaskSquareClaimResponse {
  task: TaskSquareTask
  assignment: TaskSquareAssignment
  claimed_project: Project
  start_request: Record<string, any>
}

export const taskSquareApi = {
  list: (config?: RequestConfig) => request.get<TaskSquareListResponse>('/task-square', config),
  getById: (taskId: number) => request.get<TaskSquareTask>(`/task-square/${taskId}`),
  publish: (payload: TaskSquarePublishPayload) => request.post<TaskSquareTask>('/task-square/publish', payload),
  updateStatus: (taskId: number, status: TaskSquareStatus) => request.patch<TaskSquareTask>(`/task-square/${taskId}/status`, { status }),
  claim: (taskId: number) => request.post<TaskSquareClaimResponse>(`/task-square/${taskId}/claim`),
}